import Phaser from 'phaser';

export default class BattleScene extends Phaser.Scene {
  constructor() {
    super('BattleScene');
  }
  create() {
    this.add.text(300, 250, 'Battle Scene', { fontSize: '32px', fill: '#fff' });
  }
}
